import { render, staticRenderFns } from "./PacienteFichaDadosGerais.vue?vue&type=template&id=7e3a2368&scoped=true"
import script from "./PacienteFichaDadosGerais.vue?vue&type=script&lang=js"
export * from "./PacienteFichaDadosGerais.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaDadosGerais.vue?vue&type=style&index=0&id=7e3a2368&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a2368",
  null
  
)

export default component.exports